import React from "react";
import { useNavigate } from "react-router-dom";

export default function Supplements() {
  const navigate = useNavigate();

  return (
    <div className="font-sans">

      {/* ================= HERO ================= */}
      <section className="bg-gradient-to-br from-pink-50 via-white to-purple-50 py-24 px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-extrabold text-pink-700 leading-tight">
          Hormone-Friendly Supplements
          <br /> Women Love
        </h1>

        <p className="mt-6 max-w-3xl mx-auto text-gray-700 text-lg md:text-xl">
          Supplements can play a supportive role in maintaining hormonal balance,
          boosting energy, and filling nutritional gaps when diet alone isn’t enough.
        </p>

        <button
          onClick={() => navigate("/category/supplements")}
          className="mt-6 px-6 py-2 bg-pink-500 text-white rounded-full font-semibold hover:bg-pink-600 transition"
        >
          Explore Hormone-Supporting Picks →
        </button>
      </section>

      {/* ================= CONTENT ================= */}
      <section className="max-w-4xl mx-auto px-6 py-16 space-y-16 text-gray-700">

        {/* WHY SUPPLEMENTS MATTER */}
        <div className="flex flex-col md:flex-row items-start gap-6">
          <img
            src="/assets/5.png"
            alt="Hormone Supplements"
            className="w-full md:w-1/4 rounded-xl shadow-lg"
          />
          <div>
            <h2 className="text-3xl font-bold text-pink-600 mb-4">
              Why Hormone-Friendly Supplements Matter
            </h2>
            <p className="text-lg leading-relaxed">
              Modern lifestyles, stress, and dietary limitations can make it difficult
              for women to get all essential nutrients from food alone.
              Hormone-friendly supplements help support the body’s natural processes by
              providing vitamins, minerals, and nutrients that contribute to energy,
              mood balance, and metabolic health.
              <br /><br />
              When chosen wisely, supplements can complement a healthy diet and lifestyle,
              helping women feel more balanced, focused, and resilient.
            </p>
          </div>
        </div>

        {/* POPULAR SUPPLEMENTS */}
        <div className="flex flex-col md:flex-row-reverse items-start gap-6">
          <img
            src="/assets/5.png"
            alt="Supplements for Hormones"
            className="w-full md:w-1/2 rounded-xl shadow-lg"
          />
          <div>
            <h2 className="text-3xl font-bold text-pink-600 mb-4">
              Popular Hormone-Supporting Supplements
            </h2>

            <ul className="list-disc list-inside text-lg space-y-2">
              <li><strong className="text-pink-500">Magnesium:</strong> Supports stress response, relaxation, and sleep</li>
              <li><strong className="text-pink-500">Vitamin D:</strong> Supports mood, immunity, and hormone regulation</li>
              <li><strong className="text-pink-500">Omega-3:</strong> Supports inflammation balance and brain health</li>
              <li><strong className="text-pink-500">Inositol:</strong> Supports insulin sensitivity and hormonal balance</li>
              <li><strong className="text-pink-500">Women’s Multivitamins:</strong> Help fill daily nutrient gaps</li>
            </ul>

            <p className="text-lg mt-4">
              Choosing high-quality, well-formulated supplements and using them consistently
              can make a meaningful difference over time. Always consult a healthcare professional
              if you have specific health concerns.
            </p>
          </div>
        </div>

        {/* ================= FEATURED SUPPLEMENT ================= */}
        <div className="bg-white rounded-2xl shadow-lg p-8 border border-pink-100">
          <h3 className="text-2xl font-bold text-pink-700 mb-4">
            Featured Supplement: Women’s Daily Multivitamin
          </h3>

          <div className="flex flex-col md:flex-row gap-6 items-center">
            <img
              src="/assets/MV.jpeg"
              alt="Women's Multivitamins"
              className="w-full md:w-1/3 rounded-xl shadow"
            />

            <div>
              <p className="text-lg mb-4">
                Women’s multivitamins are designed to support daily nutritional needs by
                providing essential vitamins and minerals that may be missing from diet alone.
                They commonly support energy production, immune function, bone health,
                and overall hormonal wellness.
                <br /><br />
                A quality multivitamin can be especially helpful during times of stress,
                busy schedules, or dietary changes, helping the body stay nourished and balanced.
              </p>

              <a
                href="https://amzn.to/3LW5blx"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-2 bg-pink-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-pink-600 transition"
              >
                Shop Women’s Multivitamins →
              </a>
            </div>
          </div>
        </div>

        {/* ================= AMAZON CTA ================= */}
        <div className="bg-gradient-to-br from-pink-50 via-white to-purple-50 rounded-2xl p-10 text-center shadow-lg">
          <h3 className="text-2xl md:text-3xl font-bold text-pink-700 mb-4">
            Shop Hormone-Supporting Supplements
          </h3>

          <p className="text-gray-700 max-w-2xl mx-auto mb-6 text-lg md:text-xl">
            Explore carefully curated supplements that support balanced hormones,
            energy, and everyday wellness.
          </p>

          <button
            onClick={() => navigate("/category/supplements")}
            className="bg-pink-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-pink-600 transition"
          >
            View Supplements →
          </button>
        </div>
      </section>

      {/* ================= DISCLAIMER ================= */}
      <section className="bg-gray-50 py-12 px-6 text-center">
        <p className="max-w-3xl mx-auto text-sm text-gray-600">
          This content is for educational purposes only and does not replace professional medical advice.
          Always consult a healthcare professional before starting supplements.
          As an Amazon Associate, Glow Picks may earn from qualifying purchases.
        </p>
      </section>

    </div>
  );
}
